<ion-header>
  <ion-toolbar>
    @if (showBackButton) {
      <ion-icon (click)="goBack()" name="arrow-back-outline"></ion-icon>
    }
    <img src="{{ logoUrl }}" />
  </ion-toolbar>
</ion-header>
